export const azure = {
  azure0: '#ffffff',
  azure1: '#f0f8ff',
  azure2: '#d6e8ff',
  azure3: '#bcd8ff',
  azure4: '#a1c7ff',
  azure5: '#87b7ff',
  azure6: '#6ca7ff',
  azure7: '#5197ff',
  azure8: '#3687ff',
  azure9: '#1b77ff',
  azure10: '#0066ff',
  azure11: '#0055e6',
  azure12: '#0044cc',
} as const;

export const blue = {
  azure0: '#e7f5ff',
  azure1: '#d0ebff',
  azure2: '#a5d8ff',
  azure3: '#74c0fc',
  azure4: '#4dabf7',
  azure5: '#339af0',
  azure6: '#228be6',
  azure7: '#1c7ed6',
  azure8: '#1971c2',
  azure9: '#1864ab',
} as const;

export const cherry = {
  cherry0: '#fff0f0',
  cherry1: '#ffcccc',
  cherry2: '#ffa6a6',
  cherry3: '#ff8080',
  cherry4: '#ff5959',
  cherry5: '#ff3333',
  cherry6: '#ff0d0d',
  cherry7: '#e60000',
  cherry8: '#cc0000',
  cherry9: '#b30000',
  cherry10: '#990000',
  cherry11: '#800000',
  cherry12: '#660000',
} as const;

export const lemon = {
  lemon0: '#ffffff',
  lemon1: '#fffff0',
  lemon2: '#ffffcc',
  lemon3: '#ffffa6',
  lemon4: '#ffff80',
  lemon5: '#ffff59',
  lemon6: '#ffff33',
  lemon7: '#ffff0d',
  lemon8: '#e6e600',
  lemon9: '#cccc00',
  lemon10: '#b3b300',
  lemon11: '#999900',
  lemon12: '#808000',
} as const;

export const lime = {
  lime0: '#f4fff0',
  lime1: '#e7ffdb',
  lime2: '#d1ffbc',
  lime3: '#b9ff9c',
  lime4: '#9dff78',
  lime5: '#7bff51',
  lime6: '#57ff2c',
  lime7: '#36ff13',
  lime8: '#1de800',
  lime9: '#0ec100',
  lime10: '#365314',
  lime11: '#009900',
  lime12: '#008000',
} as const;

export const hyper = {
  hyper0: '#ffffff',
  hyper1: '#fdf4ff',
  hyper2: '#fae8ff',
  hyper3: '#f5d0fe',
  hyper4: '#f0abfc',
  hyper5: '#e879f9',
  hyper6: '#d946ef',
  hyper7: '#c026d3',
  hyper8: '#a21caf',
  hyper9: '#86198f',
  hyper10: '#701a75',
  hyper11: '#4a044e',
  hyper12: '#000000',
} as const;

/**
 * @azure
 * @cherry
 * @lemon
 * @lime
 * @hyper
 *
 * 1 / 12
 */
